<template>
  <div class="radio-item-slot">
    <label class="label mb-0" :for="id">
      <slot name="content"></slot>
      <div class="radio-button">
        <input
            class="radio"
            type="radio"
            :id="id"
            :name="name"
            :value="value"
            v-model="selected"
            @click="selectedRadio(value)"
        />
        <span class="checkmark"></span>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: "SOInputRadioSlot",
  props: [
    "id",
    "name",
    "value",
    "radioSelected",
  ],
  data() {
    return {
      selected: "",
    }
  },
  methods: {
    selectedRadio(value) {
      this.$emit("selected-radio", value)
    }
  },
  mounted() {
    this.selected = this.radioSelected
  },
}
</script>

<style scoped>
.label {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  padding: 12px 20px;
  cursor: pointer;

  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  border-bottom: 1px solid #EDEDED;
}

.radio-button {
  width: 1rem;
  height: 1rem;
  position: relative;
}

.radio-button input {
  position: absolute;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}

.checkmark {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #C8D0DD;
  border-radius: 50%;
}

.radio-button input:checked ~ .checkmark {
  background-color: #206CFF;
  border: none;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.radio-button input:checked ~ .checkmark:after {
  display: block;
}

.radio-button .checkmark:after {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: white;
}
</style>